import React from "react";
import ContentLoader from "react-content-loader";
import {
  Container as MenuContainer,
  Header,
  Buttons,
  Button,
  UserMenu,
} from "../menu/styles";
import {
  MainContent,
  HeaderSkeleton,
  StatusBarSkeleton,
  ContentSkeleton,
  LoadingContainer,
} from "./styles";
import LogoFull from "../../imgs/logo.png";

const LoadingScreen = ({ isDark = true }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";
  
  // Cores hardcoded menos escuras para o menu
  const menuBackgroundColor = "#151515";
  const menuForegroundColor = "#1f1f1f";

  return (
    <LoadingContainer>
      {/* Menu Lateral usando estilos reais */}
      <MenuContainer $menuMinimized={false}>
        <Header $menuMinimized={false}>
          <img src={LogoFull} alt="Vidal" className="logo-full" />
        </Header>

        <Buttons>
          {/* Seção Dashboards */}
          <div className="menu-section">
            {[...Array(6)].map((_, i) => (
              <Button key={`dash-${i}`} $menuMinimized={false} $active={false}>
                <ContentLoader
                  speed={2}
                  width={16}
                  height={16}
                  backgroundColor={menuBackgroundColor}
                  foregroundColor={menuForegroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="16" height="16" />
                </ContentLoader>
                <p>
                  <ContentLoader
                    speed={2}
                    width={100}
                    height={13}
                    backgroundColor={menuBackgroundColor}
                    foregroundColor={menuForegroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100" height="13" />
                  </ContentLoader>
                </p>
              </Button>
            ))}
          </div>

          {/* Seção Ferramentas */}
          <div className="menu-section">
            {[...Array(3)].map((_, i) => (
              <Button key={`tool-${i}`} $menuMinimized={false} $active={false}>
                <ContentLoader
                  speed={2}
                  width={16}
                  height={16}
                  backgroundColor={menuBackgroundColor}
                  foregroundColor={menuForegroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="16" height="16" />
                </ContentLoader>
                <p>
                  <ContentLoader
                    speed={2}
                    width={120}
                    height={13}
                    backgroundColor={menuBackgroundColor}
                    foregroundColor={menuForegroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="120" height="13" />
                  </ContentLoader>
                </p>
              </Button>
            ))}
          </div>

          {/* Seção Configurações */}
          <div className="menu-section">
            {[...Array(3)].map((_, i) => (
              <Button key={`config-${i}`} $menuMinimized={false} $active={false}>
                <ContentLoader
                  speed={2}
                  width={16}
                  height={16}
                  backgroundColor={menuBackgroundColor}
                  foregroundColor={menuForegroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="16" height="16" />
                </ContentLoader>
                <p>
                  <ContentLoader
                    speed={2}
                    width={90}
                    height={13}
                    backgroundColor={menuBackgroundColor}
                    foregroundColor={menuForegroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="90" height="13" />
                  </ContentLoader>
                </p>
              </Button>
            ))}
          </div>
        </Buttons>

        <UserMenu $menuMinimized={false}>
          <div className="user">
            <div className="thumb">
              <div className="circle">
                <ContentLoader
                  speed={2}
                  width={35}
                  height={35}
                  backgroundColor={menuBackgroundColor}
                  foregroundColor={menuForegroundColor}
                >
                  <circle cx="17.5" cy="17.5" r="17.5" />
                </ContentLoader>
              </div>
            </div>
            <div className="text">
              <p className="user-name">
                <ContentLoader
                  speed={2}
                  width={100}
                  height={14}
                  backgroundColor={menuBackgroundColor}
                  foregroundColor={menuForegroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="100" height="14" />
                </ContentLoader>
              </p>
              <p className="user-email">
                <ContentLoader
                  speed={2}
                  width={120}
                  height={11}
                  backgroundColor={menuBackgroundColor}
                  foregroundColor={menuForegroundColor}
                >
                  <rect x="0" y="0" rx="3" ry="3" width="120" height="11" />
                </ContentLoader>
              </p>
            </div>
          </div>
        </UserMenu>
      </MenuContainer>
    </LoadingContainer>
  );
};

export default LoadingScreen;
